export const loginAr = {
  "Username": "اسم المستخدم",
  "Password": "كلمة المرور",
  "Connecter": "اتصال",
  "Wrong Data !": "بيانات خاطئة !",
  "Wrong Data !!": "بيانات خاطئة !!",
}